import { Footer, Testimonial } from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
export default function TestimonialPage() {
  return <>
  <PageHero title="Testimonial" bgImage={aboutBg} />
  <Testimonial />
  <Footer/>
  </>;
}
